<template>
  <div class="api-account">
    <!-- 搜索表单 -->
    <!-- <el-card class="search-card">
      <el-form :model="searchForm" ref="searchForm" :inline="true" class="search-form">
        <el-form-item label="渠道ID" prop="channel_id">
          <el-input
            v-model="searchForm.channel_id"
            placeholder="请输入渠道ID"
            clearable
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="对接平台" prop="owner">
          <el-input
            v-model="searchForm.owner"
            placeholder="请输入对接平台"
            clearable
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
            clearable
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-select v-model="searchForm.disabled" placeholder="请选择状态" clearable style="width: 120px">
            <el-option label="启用" :value="false"></el-option>
            <el-option label="禁用" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card> -->

    <!-- 操作按钮 -->
    <el-card class="operation-card">
      <el-button 
        v-if="checkPermission('add')"
        type="primary" 
        @click="handleAdd"
      >
        新增账号
      </el-button>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="channel_id" label="渠道ID" width="100"></el-table-column>
        <el-table-column prop="app_id" label="APPID" min-width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.app_id }}</span>
            <el-button 
              type="text" 
              size="mini" 
              @click="copyToClipboard(scope.row.app_id)"
              style="margin-left: 10px"
            >
              复制
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="app_secret" label="密钥" min-width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.app_secret }}</span>
            <el-button 
              type="text" 
              size="mini" 
              @click="copyToClipboard(scope.row.app_secret)"
              style="margin-left: 10px"
            >
              复制
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="owner" label="对接平台" width="220"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
        <el-table-column prop="encrypt_key" label="加密密钥" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.encrypt_key || '-' }}</span>
            <el-button 
              type="text" 
              size="mini" 
              @click="copyToClipboard(scope.row.encrypt_key)"
              style="margin-left: 10px"
              v-if="scope.row.encrypt_key"
            >
              复制
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="disabled" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '禁用' : '启用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" min-width="150"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button 
              v-if="checkPermission('view')"
              type="text" 
              size="mini" 
              @click="handleView(scope.row)"
            >
              查看
            </el-button>
            <el-button 
              v-if="checkPermission('edit')"
              type="text" 
              size="mini" 
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button 
              v-if="checkPermission('delete')"
              type="text" 
              size="mini" 
              style="color: #f56c6c" 
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form :model="formData" :rules="formRules" ref="form" label-width="100px">
        <el-form-item label="选择渠道" prop="channel_id">
          <el-autocomplete
            v-model="formData.channel_name"
            :fetch-suggestions="queryChannels"
            placeholder="请输入渠道名称进行搜索"
            @select="handleChannelSelect"
            :disabled="isView"
            style="width: 100%"
            clearable
          >
            <template slot-scope="{ item }">
              <div>{{ item.value }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="APPID" prop="app_id">
          <el-input v-model="formData.app_id" placeholder="请输入APPID" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="密钥" prop="app_secret">
          <el-input 
            v-model="formData.app_secret" 
            :placeholder="isEdit ? '当前密钥' : '请输入密钥'" 
            :disabled="isView"
          ></el-input>
        </el-form-item>
        <el-form-item label="对接平台" prop="owner">
          <el-input v-model="formData.owner" placeholder="请输入对接平台" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="加密密钥" prop="encrypt_key">
          <el-input v-model="formData.encrypt_key" placeholder="请输入加密密钥（可选）" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input
            v-model="formData.note"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            :disabled="isView"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-radio-group v-model="formData.disabled" :disabled="isView">
            <el-radio :label="false">启用</el-radio>
            <el-radio :label="true">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ isView ? '关闭' : '取消' }}</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading" v-if="!isView">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'

export default {
  name: 'ApiAccount',
  data() {
    return {
      // 搜索表单
      searchForm: {
        channel_id: '',
        owner: '',
        phone: '',
        disabled: ''
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '新增渠道',
      dialogMode: 'add', // add, edit, view
      formData: {
        id: null,
        channel_id: '',
        channel_name: '', // 用于显示渠道名称
        app_id: '',
        app_secret: '',
        owner: '',
        phone: '',
        encrypt_key: '',
        note: '',
        disabled: false
      },
      // 渠道相关数据
      channelList: [],
      channelLoading: false,
      formRules: {
        channel_id: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        app_id: [
          { required: true, message: '请输入APPID', trigger: 'blur' }
        ],
        app_secret: [
          { required: true, message: '请输入密钥', trigger: 'blur' },
          { min: 6, message: '密钥长度不能少于6位', trigger: 'blur' }
        ],
        owner: [
          { required: true, message: '请输入对接平台', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      submitLoading: false
    }
  },
  computed: {
    isEdit() {
      return this.dialogMode === 'edit'
    },
    isView() {
      return this.dialogMode === 'view'
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 检查权限
    checkPermission(action) {
      // 这里可以根据用户角色或权限配置来判断
      // 暂时返回true，实际项目中需要根据具体权限系统实现
      const userRole = getCookie('role') || 'admin'
      
      // 示例权限控制逻辑
      const permissions = {
        'admin': ['view', 'add', 'edit', 'delete'],
        'operator': ['view', 'add', 'edit'],
        'viewer': ['view']
      }
      
      return permissions[userRole] && permissions[userRole].includes(action)
    },

    // 统一错误处理
    handleApiError(error, defaultMessage = '操作失败') {
      console.error('API错误:', error)
      
      if (error.response) {
        // 服务器返回错误状态码
        const status = error.response.status
        switch (status) {
          case 401:
            this.$message.error('登录已过期，请重新登录')
            // 可以在这里跳转到登录页
            // this.$router.push('/login')
            break
          case 403:
            this.$message.error('权限不足，无法执行此操作')
            break
          case 404:
            this.$message.error('请求的资源不存在')
            break
          case 500:
            this.$message.error('服务器内部错误，请稍后重试')
            break
          default:
            this.$message.error(error.response.data?.err_msg || defaultMessage)
        }
      } else if (error.request) {
        // 网络错误
        this.$message.error('网络连接失败，请检查网络设置')
      } else {
        // 其他错误
        this.$message.error(error.message || defaultMessage)
      }
    },

    // 加载数据
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize
        }
        
        // 添加搜索参数
        if (this.searchForm.channel_id) {
          params.channel_id = this.searchForm.channel_id
        }
        if (this.searchForm.owner) {
          params.owner = this.searchForm.owner
        }
        if (this.searchForm.phone) {
          params.phone = this.searchForm.phone
        }
        if (this.searchForm.disabled !== '') {
          params.disabled = this.searchForm.disabled
        }

        const result = await this.$api.channel.getApiAccountList(params)
        
        if (result.err_code === 0) {
          this.tableData = result.rows || []
          this.pagination.total = result.total || this.tableData.length
        } else {
          this.$message.error(result.err_msg || '获取数据失败')
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请稍后重试')
        this.tableData = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      if (isNaN(date.getTime())) return ''
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    
    // 重置搜索
    handleReset() {
      this.$refs.searchForm.resetFields()
      this.pagination.currentPage = 1
      this.loadData()
    },
    
    // 新增
    handleAdd() {
      if (!this.checkPermission('add')) {
        this.$message.error('权限不足，无法新增渠道')
        return
      }
      
      this.dialogTitle = '新增渠道'
      this.dialogMode = 'add'
      this.formData = {
        channel_id: '',
        app_id: '',
        app_secret: '',
        owner: '',
        phone: '',
        encrypt_key: '',
        note: '',
        disabled: false
      }
      this.dialogVisible = true
    },

    // 查看
    async handleView(row) {
      if (!this.checkPermission('view')) {
        this.$message.error('权限不足，无法查看渠道信息')
        return
      }
      
      this.dialogTitle = '查看渠道信息'
      this.dialogMode = 'view'
      await this.loadClientInfo(row.id)
      this.dialogVisible = true
    },
    
    // 编辑
    async handleEdit(row) {
      if (!this.checkPermission('edit')) {
        this.$message.error('权限不足，无法编辑渠道')
        return
      }
      
      this.dialogTitle = '编辑渠道'
      this.dialogMode = 'edit'
      await this.loadClientInfo(row.id)
      this.dialogVisible = true
    },

    // 加载客户端详情
    async loadClientInfo(id) {
      try {
        const result = await this.$api.channel.getApiAccountInfo(id)
        
        if (result.err_code === 0 && result.client) {
          this.formData = {
            ...result.client
          }
          
          // 如果有渠道ID，获取渠道信息来回显渠道名称
          if (this.formData.channel_id) {
            await this.loadChannelName(this.formData.channel_id)
          }
        } else {
          this.$message.error(result.err_msg || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error('网络错误，请稍后重试')
      }
    },

    // 根据渠道ID获取渠道名称
    async loadChannelName(channelId) {
      try {
        const result = await this.$api.channel.getChannelList({})
        
        if (result.err_code === 0 && result.rows) {
          const channel = result.rows.find(item => item.id === channelId)
          if (channel) {
            this.formData.channel_name = `${channel.realname}(${channel.alias})`
          }
        }
      } catch (error) {
        console.error('获取渠道名称失败:', error)
      }
    },
    
    // 删除
    handleDelete(row) {
      if (!this.checkPermission('delete')) {
        this.$message.error('权限不足，无法删除渠道')
        return
      }
      
      this.$confirm('确定要删除该渠道吗？删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const result = await this.$api.channel.deleteApiAccount(row.id)
          
          if (result.err_code === 0) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(result.err_msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请稍后重试')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 复制到剪贴板
    copyToClipboard(text) {
      if (!text) {
        this.$message.warning('内容为空，无法复制')
        return
      }
      
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
        document.body.removeChild(textArea)
      }
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const submitData = { ...this.formData }
            
            const result = this.dialogMode === 'add' 
              ? await this.$api.channel.addApiAccount(submitData)
              : await this.$api.channel.updateApiAccount(submitData)
            
            if (result.err_code === 0) {
              this.$message.success(this.dialogMode === 'add' ? '新增成功' : '编辑成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(result.err_msg || '操作失败')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请稍后重试')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.$refs.form.resetFields()
      // 清空渠道名称
      this.formData.channel_name = ''
    },
    
    // 分页
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },

    // 查询渠道列表
    async queryChannels(queryString, cb) {
      try {
        this.channelLoading = true
        const params = {}
        
        const result = await this.$api.channel.getChannelList(params)
        
        if (result.err_code === 0 && result.rows) {
          let results = result.rows.map(item => ({
            value: `${item.realname}(${item.alias})`,
            id: item.id,
            realname: item.realname,
            alias: item.alias
          }))
          
          // 如果有查询字符串，进行过滤
          if (queryString) {
            results = results.filter(item => {
              const searchText = `${item.realname || ''}${item.alias || ''}`.toLowerCase()
              return searchText.includes(queryString.toLowerCase())
            })
          }
          
          cb(results)
        } else {
          cb([])
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        cb([])
      } finally {
        this.channelLoading = false
      }
    },

    // 渠道选择事件
    handleChannelSelect(item) {
      this.formData.channel_name = item.value
      this.formData.channel_id = item.id
    }
  }
}
</script>

<style scoped>
.api-account {
  padding: 20px;
}

.search-card,
.operation-card,
.table-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}
</style>